module.exports = __webpack_public_path__ + "static/media/logoeyespot_claim.844f73d4.png";